import { ReactNode } from "react";
import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/creatable";

import { FormError } from "../FormError";
import { FormLabel } from "../FormLabel";

const styles = (theme: "light" | "dark") => ({
  control: (styles: any) => {
    return {
      ...styles,
      border: theme === "light" ? "1px solid #f2f2f2" : "1px solid #fff",
      background: theme === "light" ? "#f2f2f2" : "#fff",
      minHeight: 38,
      fontSize: 14,
      borderRadius: 10,
      transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",

      "&:focus-within": {
        background: "#fff",
        border: "1px solid #4c9aff",
        boxShadow: "none"
      },
      "&:hover": {
        background: "#e9ebef",
        border: "1px solid #dee0e6"
      }
    };
  },
  placeholder: (defaultStyles: any) => {
    return {
      ...defaultStyles,
      color: "#7a869a",
      fontSize: 14
    };
  },
  menu: (base: any) => ({ ...base, overflow: "hidden" }),

  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (styles: any, { isDisabled, isSelected }: any) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#deebff" : "#fff",
      color: isSelected ? "#0052cc" : "#333",
      borderLeftWidth: 2,
      borderColor: isSelected ? "#0052cc" : "#fff",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        borderLeftWidth: 2,
        borderColor: "#0052cc",
        background: isSelected ? "#deebff" : "#f7f7f7"
      }
    };
  },
  dropdownIndicator: (base: any) => ({
    ...base,
    color: "#666"
  })
});

interface IProps {
  title: string;
  titleClasses?: string;
  subTitle?: string;
  subTitleClasses?: string;
  name: string;
  id?: string;
  classes?: string;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: (val: boolean) => void;
  control: any;
  placeholder?: string;
  options: { label: ReactNode; value: string }[];
  isMulti?: boolean;
  theme?: "light" | "dark";
}

export function SearchableTextInput({
  title,
  titleClasses,
  subTitle,
  subTitleClasses,
  control,
  name,
  id = name,
  classes,
  options,
  placeholder,
  isMulti = false,
  theme = "light"
}: IProps) {
  return (
    <article className={classes}>
      <div className="mb-2">
        {title ? (
          <FormLabel htmlFor={name} id={id} className={titleClasses}>
            {title}
          </FormLabel>
        ) : null}
        {subTitle ? <p className={`text-sm font-light text-gray-500 ${subTitleClasses}`}>{subTitle}</p> : null}
      </div>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, name, value }, fieldState: { error } }) => {
          if (value === undefined) {
            value = undefined;
          } else if (isMulti) {
            value = options.filter(o => value.includes(o.value));
          } else {
            value = options.find(o => o.value === value);
          }

          return (
            <section>
              <AsyncSelect
                name={name}
                onChange={val => {
                  onChange(val.value);
                }}
                onBlur={onBlur}
                options={options}
                value={value}
                placeholder={placeholder}
                styles={styles(theme)}
                isMulti={isMulti}
              />
              {error ? <FormError error={error.message} id={id} /> : null}
            </section>
          );
        }}
      />
    </article>
  );
}
